// TODO: Add validation message to fields

class CheckoutForm {
	constructor() {
		if (typeof wc_checkout_params === 'undefined') {
			return false;
		}
		this.updateTimer = false
		this.xhr = false
		this.checkoutFormContainer = jQuery('form.mad-checkout-form')
		this.orderReviewContainer = jQuery('.mad-checkout-order-review')
		this.fragments = false
		this.skipValidation = false;

		// Prevent HTML5 validation which can conflict.
		this.checkoutFormContainer.attr('novalidate', 'novalidate')

		jQuery(document.body).on('update_checkout', this.updateCheckout.bind(this))
		jQuery(document.body).on('init_checkout', this.initCheckout.bind(this))

		this.checkoutFormContainer.on('input validate change', '.mad-checkout-input, select, input[type=checkbox]', this.validateField.bind(this))


		this.checkoutFormContainer.on('submit', this.submit.bind(this));
		// TODO: Add form validation

		this.checkoutFormContainer.on('update', this.triggerUpdateCheckout.bind(this));

		// TODO: Inputs/selects which update totals

		if (wc_checkout_params.is_checkout === '1') {
			jQuery(document.body).trigger('init_checkout');
		}
	}

	updateCheckout(event, args) {
		// console.log('Update Checkout');
		this.resetUpdateCheckoutTimer();
		this.updateTimer = setTimeout(this.updateCheckoutAction.bind(this), '5', args)
	}

	updateCheckoutAction(args) {
		// console.log('Update Checkout Action');
		if (this.xhr) {
			this.xhr.abort();
		}

		if (jQuery('form.checkout').length === 0) {
			return;
		}

		args = typeof args !== 'undefined' ? args : {
			update_shipping_method: true
		};

		var data = this.getCheckoutDataForOrderReview();

		// Update shipping method
		if (false !== args.update_shipping_method) {

			var shipping_methods = {};

			jQuery(
				'select.shipping_method,' +
				' input[name^="shipping_method"][type="radio"]:checked,' +
				' input[name^="shipping_method"][type="hidden"]'
			).each(function () {
				var $el = jQuery(this),
					idx = $el.data('index'),
					name = $el.attr('name'),
					val = $el.val();

				// Fallback: parse the [0] from name="shipping_method[0]"
				if (typeof idx === 'undefined') {
					var m = name.match(/shipping_method\[(\d+)\]/);
					idx = m ? m[1] : 0;
				}

				shipping_methods[idx] = val;
			});

			if (Object.keys(shipping_methods).length === 0) {
				// console.warn('[Checkout] no shipping_method inputs found!');
			}

			data.shipping_method = shipping_methods;
			// console.log('[Checkout] data.shipping_method =', shipping_methods);
		}


		window.$madUtil.blockElement('.mad-checkout-order-review__container', { icon: { size: 'large' } })

		this.xhr = jQuery.ajax({
			type: 'POST',
			url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'update_order_review'),
			data: data,
			success: (data) => { // <— Arrow Function fix
				// Reload?
				if (data && true === data.reload) { window.location.reload(); return; }

				// Zustand sichern (z.B. Terms & Coupon UI)
				let termsChecked = jQuery('#terms').length ? jQuery('#terms').prop('checked') : jQuery('#legal').prop('checked');

				// TODO: Save payment details to a temporary object
				// var paymentDetails = {};
				// jQuery( '.payment_box :input' ).each( function() {
				// 	var ID = jQuery( this ).attr( 'id' );

				// 	if ( ID ) {
				// 		if ( $.inArray( jQuery( this ).attr( 'type' ), [ 'checkbox', 'radio' ] ) !== -1 ) {
				// 			paymentDetails[ ID ] = jQuery( this ).prop( 'checked' );
				// 		} else {
				// 			paymentDetails[ ID ] = jQuery( this ).val();
				// 		}
				// 	}
				// });

				const couponContainer = jQuery('.mad-checkout-coupon').clone(true);

				// Fragments einspielen
				window.$madUtil.updateFragments(data.fragments);

				// Coupon-UI wieder einsetzen + Terms rechecken
				jQuery('.mad-checkout-coupon').replaceWith(couponContainer);
				if (jQuery('#terms').length) { jQuery('#terms').prop('checked', termsChecked); }
				else if (jQuery('#legal').length) { jQuery('#legal').prop('checked', termsChecked); }

				// Fill in the payment details if possible without overwriting data if set.
				// if ( ! $.isEmptyObject( paymentDetails ) ) {
				// 	jQuery( '.payment_box :input' ).each( function() {
				// 		var ID = jQuery( this ).attr( 'id' );
				// 		if ( ID ) {
				// 			if ( $.inArray( jQuery( this ).attr( 'type' ), [ 'checkbox', 'radio' ] ) !== -1 ) {
				// 				jQuery( this ).prop( 'checked', paymentDetails[ ID ] ).trigger( 'change' );
				// 			} else if ( $.inArray( jQuery( this ).attr( 'type' ), [ 'select' ] ) !== -1 ) {
				// 				jQuery( this ).val( paymentDetails[ ID ] ).trigger( 'change' );
				// 			} else if ( null !== jQuery( this ).val() && 0 === jQuery( this ).val().length ) {
				// 				jQuery( this ).val( paymentDetails[ ID ] ).trigger( 'change' );
				// 			}
				// 		}
				// 	});
				// }
				if (data && 'failure' === data.result) {
					this.submitError(data.messages || '<div class="woocommerce-error">Fehler beim Aktualisieren.</div>');

					this.scrollToNotices();
				}

				window.$madUtil.unblockElement('.mad-checkout-order-review__container');
				jQuery(document.body).trigger('updated_checkout', [data]);
			},
			error: () => {
				window.$madUtil.unblockElement('.mad-checkout-order-review__container');
			}
		});


	}

	getCheckoutDataForOrderReview() {
		var postcode = jQuery(':input#billing_postcode').val(),
			state = jQuery('#billing_state').val(),
			country = jQuery('#billing_country').val(),
			city = jQuery('#billing_city').val(),
			address = jQuery(':input#billing_address_1').val(),
			postcode = jQuery(':input#billing_postcode').val(),
			address2 = jQuery(':input#billing_address_2').val(),
			shippingCountry = country,
			shippingState = state,
			shippingPostcode = postcode,
			shippingCity = city,
			shippingAddress = address,
			shippingAddress2 = address2,
			requiredInputs = jQuery(this.checkoutFormContainer).find('.address-field.validate-required:visible'),
			hasFullAddress = true,
			shipToDifferentAddress = jQuery('input#ship-to-different-address-checkbox').is(':checked'),
			legal = jQuery('input#legal').is(':checked');

		if (requiredInputs.length) {
			requiredInputs.each(function () {
				if (jQuery(this).find(':input').val() === '') {
					hasFullAddress = false;
				}
			});
		}

		if (shipToDifferentAddress) {
			shippingCountry = jQuery('#shipping_country').val();
			shippingState = jQuery('#shipping_state').val();
			shippingPostcode = jQuery(':input#shipping_postcode').val();
			shippingCity = jQuery('#shipping_city').val();
			shippingAddress = jQuery(':input#shipping_address_1').val();
			shippingAddress2 = jQuery(':input#shipping_address_2').val();
		}

		var data = {
			security: wc_checkout_params.update_order_review_nonce,
			payment_method: this.getPaymentMethod(),
			country: country,
			state: state,
			postcode: postcode,
			city: city,
			address: address,
			address_2: address2,
			s_country: shippingCountry,
			s_state: shippingState,
			s_postcode: shippingPostcode,
			s_city: shippingCity,
			s_address: shippingAddress,
			s_address_2: shippingAddress2,
			has_full_address: hasFullAddress ? 1 : 0,
			legal: legal,
			post_data: jQuery('form.checkout').serialize()
		};

		return data;
	}



	initCheckout() {
		// TODO
	}

	validateField(e) {
		var target = jQuery(e.target),
			parent = target.closest('.mad-checkout-input__container'),
			validated = true,
			validate_required = parent.is('.validate-required'),
			validate_email = parent.is('.validate-email'),
			validate_phone = parent.is('.validate-phone'),
			validate_if_shipping_to_different_address = parent.is('.validate-if-shipping-to-different-address'),
			pattern = '',
			event_type = e.type;

		// if (target.is('#ship-to-different-address-checkbox') && !target.is(':checked')) {
		// 	// Copy billing address to shipping address if checkbox is unchecked
		// 	const fieldsToCopy = [
		// 		'first_name', 'last_name', 'address_1', 'address_2', 'city', 'postcode', 'country', 'state'
		// 	];

		// 	fieldsToCopy.forEach(field => {
		// 		const billingValue = jQuery(`#billing_${field}`).val();
		// 		jQuery(`#shipping_${field}`).val(billingValue).trigger('change');
		// 	});
		// }

		if ('input' === event_type) {
			parent.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email woocommerce-invalid-phone woocommerce-validated');
		}

		if ('validate' === event_type || 'change' === event_type) {

			if (validate_required) {

				if ('checkbox' === target.attr('type') && !target.is(':checked')) {

					parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
					validated = false;

				} else if ('radio' === target.attr('type')) {

					// Check if any radio button in the group is checked
					var name = target.attr('name');
					if (jQuery('input[name="' + name + '"]:checked').length === 0) {
						parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
						validated = false;
					}

				} else if (target.val() === '') {

					parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-required-field');
					validated = false;
				}

			}
		}

		if (validate_email) {
			if (target.val()) {
				/* https://stackoverflow.com/questions/2855865/jquery-validate-e-mail-address-regex */
				pattern = new RegExp(/^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[0-9a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i);

				if (!pattern.test(target.val())) {
					parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-email woocommerce-invalid-phone');
					validated = false;
				}
			}
		}

		if (validate_phone) {
			pattern = new RegExp(/[\s\#0-9_\-\+\/\(\)\.]/g);

			if (0 < target.val().replace(pattern, '').length) {
				parent.removeClass('woocommerce-validated').addClass('woocommerce-invalid woocommerce-invalid-phone');
				validated = false;
			}
		}

		if (validate_if_shipping_to_different_address && !jQuery('input#ship-to-different-address-checkbox').is(':checked')) {
			validated = true;
		}

		if (this.skipValidation) {
			validated = true;
		}

		var noticeContainer = parent.closest('.mad-notice');

		if (validated) {
			parent
				.removeClass('woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email woocommerce-invalid-phone')
				.addClass('woocommerce-validated');
			if (noticeContainer.length > 0) {
				noticeContainer.removeClass('invalid');
			}
		} else {
			if (noticeContainer.length > 0) {
				noticeContainer.addClass('invalid');
			}
		}
	}

	submit(e) {
		e.preventDefault();

		var button = this.checkoutFormContainer.find('.mad-checkout-steps__button.final');

		if (e.originalEvent && jQuery(e.originalEvent.submitter).attr('type') !== 'submit' && !button.hasClass('disabled')) {
			button.addClass('failure');
			return false;
		}

		// Block the button and remove any previous success or failure class
		button.removeClass('success failure');
		// window.$madUtil.blockElement(button, { icon: { positionX: 'right', size: 'small' } });

		// Reset the timer and the processing state
		this.resetUpdateCheckoutTimer();
		let $form = this.checkoutFormContainer;

		if ($form.is('.processing')) {
			return false;
		}

		// Validate the form before submission
		if (!$form[0].checkValidity()) {
			// Form has invalid fields
			$form.find('.mad-checkout-input:invalid').first().focus();
			// window.$madUtil.unblockElement(button);
			return false;
		}

		// Trigger a handler to let gateways manipulate the checkout if needed
		const globalOk = $form.triggerHandler('checkout_place_order', [this]) !== false;
		const gatewayOk = $form.triggerHandler('checkout_place_order_' + this.getPaymentMethod(), [this]) !== false;

		if (globalOk && gatewayOk) {

			$form.addClass('processing');

			// Attach event to block reloading the page when the form has been submitted
			jQuery(window).on('beforeunload', this.handleUnloadEvent);

			jQuery.ajaxSetup({
				dataFilter: function (raw_response, dataType) {
					// We only want to work with JSON
					if ('json' !== dataType) {
						return raw_response;
					}

					if (window.$madUtil.isValidJson(raw_response)) {
						return raw_response;
					} else {
						// Attempt to fix the malformed JSON
						var maybe_valid_json = raw_response.match(/{"result.*}/);

						if (null === maybe_valid_json) {
							// console.log('Unable to fix malformed JSON');
						} else if (window.$madUtil.isValidJson(maybe_valid_json[0])) {
							// console.log('Fixed malformed JSON. Original:');
							// console.log(raw_response);
							raw_response = maybe_valid_json[0];
						} else {
							// console.log('Unable to fix malformed JSON');
						}
					}

					return raw_response;
				}
			});

			jQuery.ajax({
				type: 'POST',
				url: wc_checkout_params.checkout_url,
				data: $form.serialize(),
				dataType: 'json',
				success: (result) => {
					// Unblock the button
					// window.$madUtil.unblockElement(button);

					// Detach the unload handler that prevents a reload / redirect
					jQuery(window).off('beforeunload', this.handleUnloadEvent);

					try {
						if ('success' === result.result && $form.triggerHandler('checkout_place_order_success', [result, this]) !== false) {
							if (result.redirect.indexOf('https://') === 0 || result.redirect.indexOf('http://') === 0) {
								window.location = decodeURI(result.redirect);
							} else {
								window.location = result.redirect;
							}
						} else if ('failure' === result.result) {
							throw 'Result failure';
						} else {
							throw 'Invalid response';
						}
					} catch (err) {
						// Reload page
						if (true === result.reload) {
							window.location.reload();
							return;
						}

						// Trigger update in case we need a fresh nonce
						if (true === result.refresh) {
							jQuery(document.body).trigger('update_checkout');
						}

						// Add new errors
						if (result.messages) {
							this.submitError(result.messages);
						} else {
							this.submitError('<div class="woocommerce-error">' + wc_checkout_params.i18n_checkout_error + '</div>');
						}

						button.addClass('failure');
					}
				},
				error: (jqXHR, textStatus, errorThrown) => {
					// Unblock the button
					// window.$madUtil.unblockElement(button);

					// Detach the unload handler that prevents a reload / redirect
					jQuery(window).off('beforeunload', this.handleUnloadEvent);

					this.submitError('<div class="woocommerce-error">' + (errorThrown || wc_checkout_params.i18n_checkout_error) + '</div>');
					button.addClass('failure');
				}
			});
		} else {
			// window.$madUtil.unblockElement(button);
			// console.log('test', { globalOk, gatewayOk })
			return false;
		}

		return false;
	}


	submitError(errorMessage) {
		var noticesWrapper = jQuery('.woocommerce-notices-wrapper');
		console.log('Error:', noticesWrapper, errorMessage);

		if (noticesWrapper.length) {
			noticesWrapper.children().remove();
			noticesWrapper.append(jQuery(errorMessage));
		}

		this.checkoutFormContainer.removeClass('processing');
		this.checkoutFormContainer.find('.input-text, select, input:checkbox').trigger('validate').trigger('blur');
		this.scrollToNotices();
		jQuery(document.body).trigger('checkout_error', [errorMessage]);
	}

	handleUnloadEvent(e) {
		// console.log('Handle unload event');
		e.preventDefault();
		return undefined;
	}

	scrollToNotices() {
		var scrollElement = jQuery('.woocommerce-notices-wrapper');

		if (!scrollElement.length) {
			scrollElement = jQuery('form.checkout');
		}
		window.madScrollTo(scrollElement);
	}



	triggerUpdateCheckout() {
		this.resetUpdateCheckoutTimer();
		jQuery(document.body).trigger('update_checkout');
	}

	resetUpdateCheckoutTimer() {
		clearTimeout(this.updateTimer);
	}

	getPaymentMethod() {
		return this.checkoutFormContainer.find('input[name="payment_method"]:checked').val();
	}

}

module.exports = CheckoutForm;